import React from 'react';
import { Typography, Space, Tag, DatePicker, Button, Badge } from 'antd';
import {
  LockOutlined,
  SyncOutlined,
  ReloadOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

export interface JournalEntriesHeaderBarProps {
  dates: [dayjs.Dayjs, dayjs.Dayjs];
  onDatesChange: (dates: [dayjs.Dayjs, dayjs.Dayjs]) => void;
  lockDate?: string | null;
  isRefreshing: boolean;
  onRefresh: () => void;
  pendingCount: number;
  isReprocessing: boolean;
  onOpenPendingModal: () => void;
  onOpenCreateModal: () => void;
}

export const JournalEntriesHeaderBar: React.FC<JournalEntriesHeaderBarProps> = ({
  dates,
  onDatesChange,
  lockDate,
  isRefreshing,
  onRefresh,
  pendingCount,
  isReprocessing,
  onOpenPendingModal,
  onOpenCreateModal,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 12,
      }}
    >
      <div>
        <Title level={3} style={{ margin: 0 }}>
          Comprobantes de Diario
        </Title>
        <Text type="secondary">
          Libro diario contable y registro de transacciones
        </Text>
      </div>

      <Space wrap align="center">
        {lockDate && (
          <Tag color="error" icon={<LockOutlined />}>
            Cerrado hasta: {dayjs(lockDate).format('DD/MM/YYYY')}
          </Tag>
        )}

        <RangePicker
          value={dates}
          onChange={(d) => d && onDatesChange([d[0]!, d[1]!])}
          format="DD/MM/YYYY"
        />

        <Button
          icon={<SyncOutlined spin={isRefreshing} />}
          onClick={onRefresh}
        >
          Refrescar
        </Button>

        <Badge count={pendingCount} offset={[-4, 4]}>
          <Button
            danger={pendingCount > 0}
            icon={<ReloadOutlined spin={isReprocessing} />}
            onClick={onOpenPendingModal}
          >
            Reprocesar Pendientes
          </Button>
        </Badge>

        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={onOpenCreateModal}
        >
          Nuevo Asiento Manual
        </Button>
      </Space>
    </div>
  );
};
